import React from 'react';

import { LoadableAfterPaint, LoadableBackground } from '@confluence/loadable';

import { ReactionsPlaceholder } from './ReactionsPlaceholder';
import { ReactionsSummaryViewPlaceholder } from './ReactionsSummaryViewPlaceholder';

export const ReactionsLoader = LoadableAfterPaint({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder useAccuratePills {...props} />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ './Reactions')).Reactions,
});

export const ReactionsLoaderBackground = LoadableBackground({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ './Reactions')).Reactions,
});
